export default __webpack_public_path__ + "static/media/baliuag.7dcccdcb.jpg";